import { Injector, Pipe, PipeTransform } from '@angular/core';
import * as moment from "@node_modules/moment";

@Pipe({
    name: 'humanizeDate'
})
export class HumanizeDatePipe implements PipeTransform {

    constructor() {}

    transform(feature: moment.Moment): string {
        const today = moment().endOf('day');
        const tomorrow = moment().add(1, "day").endOf('day');
        const yesterday = moment().subtract(1, "day").endOf('day');

        if (feature.isSame(today, "day")) {
            return 'Today';
        }

        if (feature.isSame(tomorrow, "day")) {
            return 'Tomorrow';
        }

        if (feature.isSame(yesterday, "day")) {
            return 'Yesterday';
        }

        return feature.format('DD/MM/YY');
    }
}
